export default [
  {
    key: 'elements',
    label: 'Envato Elements',
    imageSrc: '/images/cross-sell__elements.jpg',
    imageSrcSet: [ '/images/cross-sell__elements.jpg', '/images/cross-sell__elements--2x.jpg' ],
    heading: 'Deliver better projects faster. Photos, templates & courses',
    subHeading: 'Unlimited downloads. Only $29/month',
    url: {
      base: { 'default': 'https://elements.envato.com/' },
      path: { 'default': 'all-items' },
      params: {
        themeforest: {
          utm_source: 'themeforest.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: 'tf_global-footer',
          utm_medium: 'promos'
        },
        codecanyon: {
          utm_source: 'codecanyon.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: 'cc_global-footer',
          utm_medium: 'promos'
        },
        graphicriver: {
          utm_source: 'graphicriver.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: 'gr_global-footer',
          utm_medium: 'promos'
        },
        photodune: {
          utm_source: 'photodune.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: 'pd_global-footer',
          utm_medium: 'promos'
        },
        videohive: {
          utm_source: 'videohive.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: 'vh_global-footer',
          utm_medium: 'promos'
        },
        audiojungle: {
          utm_source: 'audiojungle.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: 'aj_global-footer',
          utm_medium: 'promos'
        },
        '3docean': {
          utm_source: '3docean.net',
          utm_campaign: 'elements_mkt-footer_26JUNE2017',
          utm_content: '3do_global-footer',
          utm_medium: 'promos'
        }
      }
    }
  },
  {
    key: 'tutplus',
    label: 'Tuts+',
    imageSrc: '/images/cross-sell__tutsplus.jpg',
    imageSrcSet: [ '/images/cross-sell__tutsplus.jpg', '/images/cross-sell__tutsplus--2x.jpg' ],
    heading: 'Learn almost anything with<br>Envato Tuts+ for free',
    subHeading: '9000 free tutorials, 3000 paid courses',
    url: {
      base: {
        codecanyon: 'https://webdesign.tutsplus.com',
        themeforest: 'https://webdesign.tutsplus.com',
        'default': 'http://tutsplus.com'
      },
      path: {
        codecanyon: '/courses/a-beginners-guide-to-using-wordpress',
        themeforest: '/courses/a-beginners-guide-to-using-wordpress',
        'default': ''
      },
      params: {
        codecanyon: {
          utm_source: 'EnvatoMarket',
          utm_medium: 'TF_Footer',
          utm_campaign: 'Envato_CC_Footer_FreeWPCourse'
        },
        themeforest: {
          utm_source: 'EnvatoMarket',
          utm_medium: 'CC_Footer',
          utm_campaign: 'Envato_TF_Footer_FreeWPCourse'
        },
        'default': {
          utm_source: 'market.envato.com',
          utm_medium: 'referral',
          utm_campaign: 'global_footer'
        }
      }
    }
  },
  {
    key: 'studio',
    label: 'Envato Studio',
    imageSrc: '/images/cross-sell__studio.jpg',
    imageSrcSet: [ '/images/cross-sell__studio.jpg', '/images/cross-sell__studio--2x.jpg' ],
    heading: 'Designers matched perfectly to<br>you on Envato Studio',
    subHeading: '2000 artists ready to undertake your work',
    url: {
      base: {
        'default': 'https://studio.envato.com'
      },
      path: {
        codecanyon: '/explore/websites-programming',
        videohive: '/explore/video-animation',
        audiojungle: '/explore/audio',
        graphicriver: '/explore/design-graphics',
        photodune: '/explore/photo-editing',
        '3docean': '/explore/3d-design-modeling',
        'default': '/explore/wordpress'
      },
      params: {
        '3docean': {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: '3docean'
        },
        audiojungle: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'audiojungle'
        },
        codecanyon: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'codecanyon'
        },
        graphicriver: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'graphicriver'
        },
        photodune: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'photodune'
        },
        themeforest: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'themeforest'
        },
        videohive: {
          utm_source: 'marketplaces',
          utm_content: 'footernav',
          utm_campaign: 'internal navigation',
          utm_medium: 'videohive'
        },
        'default': {}
      }
    }
  }
]



// WEBPACK FOOTER //
// ./config/layout/crossSellLinks.js